<template>
  <i v-if="iconFileName && iconFileName.indexOf('el-icon-') === 0" :class="iconFileName" />
  <svg v-else class="svg-icon" aria-hidden="true" v-on="$listeners">
    <use :xlink:href="`#icon-${iconFileName}`" rel="external nofollow"  />
  </svg>
</template>

<script>
let iconColorNormalized = false
export default {
  name: 'SvgIcon',
  props: {
    iconFileName: {
      type: String,
      required: true,
      //default: "404"
    }
  },
  mounted() {
    if (iconColorNormalized) return
    const spriteRoot =
      document.getElementById('__SVG_SPRITE_NODE__') ||
      document.querySelector('svg[aria-hidden="true"]')
    if (!spriteRoot) return
    const fillNodes = spriteRoot.querySelectorAll('symbol [fill]')
    fillNodes.forEach(node => {
      const fill = (node.getAttribute('fill') || '').toLowerCase()
      if (fill && fill !== 'none') {
        node.setAttribute('fill', 'currentColor')
      }
    })
    const strokeNodes = spriteRoot.querySelectorAll('symbol [stroke]')
    strokeNodes.forEach(node => {
      const stroke = (node.getAttribute('stroke') || '').toLowerCase()
      if (stroke && stroke !== 'none') {
        node.setAttribute('stroke', 'currentColor')
      }
    })
    iconColorNormalized = true
  }
}
</script>

<style scoped>
.svg-icon {
  width: 1em;
  height: 1em;
  overflow: hidden;
  vertical-align: -0.2em;
  fill: currentColor;
}
</style>
